import React from 'react';
import Header from '../components/layout/Header';
import { TrendingUp } from 'lucide-react';

export default function ReportsPage() {
  return (
    <>
      <Header title="Reports" />
      <div className="app-content" style={{ padding: '20px' }}>
        <div className="card" style={{ padding: '60px 40px', textAlign: 'center' }}>
          <TrendingUp size={48} style={{ color: 'var(--zeus-gold)', marginBottom: '16px', opacity: 0.6 }} />
          <h2 style={{ fontSize: '1.3rem', fontWeight: 500, color: 'var(--text-primary)', marginBottom: '8px' }}>
            Reports
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', maxWidth: '400px', margin: '0 auto' }}>
            Reports and analytics are coming soon. You'll be able to generate detailed reports on cases, billing, staff activity, and more.
          </p>
        </div>
      </div>
    </>
  );
}
